import { getQueryKey } from '@trpc/react-query';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import api from 'lib/trpcClient';

export const useDataRoomRequests = (dataRoomId: string) => {
  const { data } = api.dataRoom.getById.useQuery({ id: dataRoomId });
  const { mutate: runUpdateMutation, isPending } =
    api.dataRoom.update.useMutation(
      useHandleTrpcMutation()({
        successMessage: 'Data room updated successfully.',
        invalidations: [getQueryKey(api.dataRoom.getById, { id: dataRoomId })],
      }),
    );

  return {
    data,
    update: runUpdateMutation,
    updating: isPending,
  };
};
